module.exports = __webpack_public_path__ + "static/media/bv.9d8569a7.svg";